export default __webpack_public_path__ + "static/media/registration-login-settings.070e8827.png";